<template>
  <form class="mb-4" @submit.prevent="handleFormSubmit">
    <aha-input-group class="my-5">
      <span class="aha-input-prepend">
        <aha-icon
          name="mail"
          viewBox="0 0 24 24"
          width="18"
          height="18"
        />
      </span>

      <aha-input
        type="email"
        class="w-full"
        placeholder="Your work or student email…"
        required
        v-model="email"
      />
    </aha-input-group>

    <div class="mb-4 text-sm text-red-100" v-if="error">
      <font-awesome-icon
        :icon="['fas', 'exclamation-triangle']"
      />
      <span v-if="error === 'default_error'">
        Oops, there's an error while logging you in. Please try again.
        If the problem persists, please contact us at
        <a href="mailto:hi@ahaslides.com">hi@ahaslides.com</a> for support.
      </span>
      <span v-else>
        {{ error }}
      </span>
    </div>

    <div class="text-center form-group">
      <div class="pb-3 col-xs-12">
        <aha-button
          type="submit"
          class="w-full"
          size="lg"
        >
          <span>Log in</span>
          <aha-spinner v-if="isSubmitting" variant="white" />
        </aha-button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    error: {
      type: String,
      default: null,
    },
    loginWithSSO: {
      type: Function,
      required: true,
    },
    isSubmitting: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      email: '',
    }
  },
  methods: {
    async handleFormSubmit() {
      if (!this.email || !this.email.trim()) {
        return
      }

      this.loginWithSSO(this.email)
    },
  },
}
</script>
